import DriverComponent from './components/DriverComponent/DriverComponent';
import VehicleComponent from './components/VehicleComponent/VehicleComponent';
import DriverAssignmentComponent from './components/DriverAssignmentComponent/DriverAssignmentComponent';
import PolicyChangeQuoteComponent from './components/PolicyChangeQuoteComponent/PolicyChangeQuoteComponent';
import PolicyChangeDetailsComponent from './components/PolicyChangeDetailsComponent/PolicyChangeDetailsComponent';
import PolicyDiffComponent from './components/PolicyDiffComponent/PolicyDiffComponent';

const policyJobComponentMap = {
    drivercomponent: { component: 'DriverComponent' },
    vehiclecomponent: { component: 'VehicleComponent' },
    driverAssignmentComponent: { component: 'DriverAssignmentComponent' },
    PolicyChangeQuoteComponent: { component: 'PolicyChangeQuoteComponent' },
    PolicyDiffComponent: { component: 'PolicyDiffComponent' },
};

const policyJobComponents = {
    DriverComponent,
    VehicleComponent,
    DriverAssignmentComponent,
    PolicyChangeQuoteComponent,
    PolicyDiffComponent
};

export {
    DriverComponent,
    VehicleComponent,
    DriverAssignmentComponent,
    PolicyChangeQuoteComponent,
    PolicyChangeDetailsComponent,
    PolicyDiffComponent,
    policyJobComponentMap,
    policyJobComponents
};
